function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Credit Card Crossed Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.1203717,0.197885858 C14.3000828,-0.0397318325 14.6157328,-0.0672500036 14.8253957,0.136422302 C15.0350586,0.340094608 15.0593394,0.697830833 14.8796283,0.935448523 L14.8796283,0.935448523 L2.8796283,16.802096 C2.69991723,17.0397137 2.38426723,17.0672319 2.17460431,16.8635596 C1.96494139,16.6598873 1.94066062,16.302151 2.1203717,16.0645333 L2.1203717,16.0645333 Z M15.6325263,2 C16.9576419,2 18,3.11238223 18,4.4544 L18,12.5456 C18,13.8876178 16.9576419,15 15.6325263,15 L4.879,14.9999909 L5.546,14.1329909 L15.6325263,14.1333333 C16.3992518,14.1333333 17.0526316,13.4360605 17.0526316,12.5456 L17.052,7.99999094 L10.264,7.99999094 L12.572,4.99999094 L17.052,4.99999094 L17.0526316,4.4544 C17.0526316,3.56393954 16.3992518,2.86666667 15.6325263,2.86666667 L14.213,2.86599094 L14.879,1.99999094 L15.6325263,2 Z M12.044,1.99999094 L11.377,2.86599094 L2.36747368,2.86666667 C1.60074817,2.86666667 0.947368421,3.56393954 0.947368421,4.4544 L0.947,4.99999094 L9.736,4.99999094 L7.428,7.99999094 L0.947,7.99999094 L0.947368421,12.5456 C0.947368421,13.4360605 1.60074817,14.1333333 2.36747368,14.1333333 L2.711,14.1329909 L2.06023312,14.9797604 C0.884744479,14.8234858 0,13.7819992 0,12.5456 L0,4.4544 C0,3.11238223 1.04235809,2 2.36747368,2 L12.044,1.99999094 Z",
  id: "icon-credit-card-crossed-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon-credit-card-crossed",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "icon-credit-card-crossed-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon-credit-card-crossed-path-1"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon-credit-card-crossed-mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-85.000000, -87.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "currentcolor",
  x: 0,
  y: 0,
  width: 191,
  height: 188
})))));

var SvgCreditCardCrossed = function SvgCreditCardCrossed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCardCrossed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit-card-crossed.83a66b7c.svg";
export { ForwardRef as ReactComponent };